import { HttpErrorResponse } from '@angular/common/http';
import { Component, Injector, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { MessageModalContentComponent } from '../message-modal-content/message-modal-content.component';

@Component({
  selector: 'app-base',
  templateUrl: './base.component.html',
  styleUrls: ['./base.component.css']
})
export class BaseComponent implements OnInit {
  isProgress: boolean;
  router: Router;
  dialogService: NgbModal;
  public static readonly ConstENF = 'ENF';
  public static readonly ConstEIR = 'EIR';
  public static readonly ConstNPC = 'NPC';
  public static readonly ConstROD = 'ROD';
  public static readonly ConstSRP = 'SRP';
  public static readonly ConstPBN = 'PBN';
  public static readonly ConstAO = 'AO';
  dialogServiceBStrap: BsModalService;
  bsModalRef: BsModalRef;

  constructor(public _injector: Injector) { 
    this.dialogService = this._injector.get(NgbModal);
    this.dialogServiceBStrap = this._injector.get(BsModalService);
  }

  ngOnInit(): void {
    this.router = this._injector.get(Router);
  }

  protected showProgress() {
    this.isProgress = true;
  }

  protected hideProgress() {
    this.isProgress = false;
  }

  public IsNullOrUndefined(variable: any): boolean {
    return (variable === null || variable === undefined || variable === '');
  }

  protected ShowErrorOnErrorFromPublishing(error: HttpErrorResponse): void {
    return this.ShowErrorMessage(error.error, "Cannot publish item.", () =>
      this.hideProgress()
    );
  }

  protected ShowErrorMessage(message: string, title?: string, callback?: Action<any>) {
    const initialState = {
      list: [message],
      title: title,
      onClose: callback
    };

    this.dialogServiceBStrap = this._injector.get(BsModalService);
    this.bsModalRef = this.dialogServiceBStrap.show(MessageModalContentComponent, { initialState });
    this.bsModalRef.content.closeBtnName = 'Close';
  }
}

type Action<T> = (item: T) => void;
